export default "__VITE_ASSET__SBLUEev7__"